import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link } from "react-router-dom";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import DownloadBtnSaleInvoicePdf from "../../Invoices/Sale/DownloadBtnSaleInvoicePdf";
import PrintBtnSaleInvoicePdf from "../../Invoices/Sale/PrintBtnSaleInvoicePdf";

let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";

if (_UserSession != undefined || _UserSession != null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}

let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession != undefined || _companySession != null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
    label: "Date",
    field: "invoice_date",
    width: 150,
  },
  {
    label: "Invoice No.",
    field: "invoice_no",
    width: 150,
  },
  {
    label: "Party",
    field: "party_name",
    width: 150,
  },
  {
    label: "Total Sale Amount",
    field: "total_amount",
    width: 150,
  },
  {
    label: "Profit(+) /  Loss(-)",
    field: "profit",
    width: 150,
  },
  {
    label: "Action",
    field: "actionExtra",
    width: 100,
  },
];

let _loader = "glb-ldr-prt active";

export default class saleReportPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonTitle: "Add Sale",
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,
      total: 0,
      totalSaleAmt: 0,
      totalProfitLoss: 0,
      startDate: moment().month("April").startOf("month").format("YYYY-MM-DD"),
      endDate: moment()
        .add(1, "year")
        .month("March")
        .endOf("month")
        .format("YYYY-MM-DD"),
      dateLabel: "",
      errors: {
        name: "",
      },
      // New modal states
      showDetailsModal: false,
      detailsData: null,
      selectedTransactionId: null,
    };
  }

  async componentDidMount() {
    this.getSaleListData();
  }

  getSaleListData() {
    let _transArray = [];
    let _totalAmt = 0;
    let totalSaleAmt = 0;
    let totalProfitLoss = 0;

    const requestData = JSON.stringify({
      business_id: this.state.businessId,
      company_id: this.state.company_id,
      type: "SALE",
      isDateFilter: true,
      start_date: this.state.startDate,
      end_date: this.state.endDate,
    });

    PostData(global.userBillWiseProfitReportList, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          this.setState({
            transactionArrayFilter: _transArray,
            isLoaded: true,
            total: _totalAmt,
            totalSaleAmt: totalSaleAmt,
            totalProfitLoss: totalProfitLoss,
          });
        } else {
          if (responseJson.response) {
            _transArray = responseJson.response;
            totalSaleAmt = responseJson.totalSaleAmt;
            totalProfitLoss = responseJson.totalProfitLoss;
            _transArray.map((itm) => {
              _totalAmt += parseFloat(itm.total_amount);
            });
          }
          this.setState({
            transactionArrayFilter: _transArray,
            isLoaded: true,
            total: _totalAmt,
            totalSaleAmt: totalSaleAmt,
            totalProfitLoss: totalProfitLoss,
          });
        }
      })
      .catch((error) => this.setState({ error, isLoaded: false }));
  }

  // Fetch details for modal
  fetchDetailsData = (transactionId) => {
    const requestData = JSON.stringify({
      business_id: this.state.businessId,
      company_id: this.state.company_id,
      transaction_id: transactionId,
    });

    // 🔹 Replace with your actual details API
    PostData(global.userBillWiseTransactionDetails, requestData, "POST")
      .then((result) => {
        if (result.success) {
          this.setState({ detailsData: result.response });
        } else {
          sendNotification("Error", result.message, "danger");
        }
      })
      .catch((err) => {
        console.error(err);
        sendNotification("Error", "Something went wrong", "danger");
      });
  };

  // Modal control
  openDetailsModal = (transactionId) => {
    this.setState({ showDetailsModal: true, selectedTransactionId: transactionId });
    this.fetchDetailsData(transactionId);
  };

  closeDetailsModal = () => {
    this.setState({ showDetailsModal: false, detailsData: null });
  };

  loadTranscListing() {
    let dataList = [];
    let rows = [];

    if (this.state.isLoaded === true) {
      let _transDetails = this.state.transactionArrayFilter;
      if (_transDetails.length > 0) {
        _transDetails.map((value, index) => {
          let _editActionUrl = global.webUrl + "business/add-sale/?auth=" + value.transaction_id;

          let _actionExtra = (
            <div className="btn-group" role="group">
              <button
                type="button"
                id="btnGroupVerticalDrop3"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="fa fa-ellipsis-v"></i>
              </button>
              <div className="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                <a className="dropdown-item" href={_editActionUrl}>
                  View/Edit Details
                </a>
                <Link
                  className="dropdown-item"
                  to={"/business/salePdfDialog/?auth=" + value.transaction_id}
                  target="_blank"
                >
                  Preview
                </Link>
                <PrintBtnSaleInvoicePdf
                  auth={value.transaction_id}
                  loading={(isLoading) => this.setState({ isPdfLoading: isLoading })}
                />
                {/* NEW: Show Details Option */}
                <button
                  className="dropdown-item"
                  onClick={() => this.openDetailsModal(value.transaction_id)}
                >
                  Show Details
                </button>
              </div>
            </div>
          );

          rows.push({
            srNo: value.srNo,
            invoice_date: moment(value.invoice_date).format("YYYY-MM-DD"),
            invoice_no: value.invoice_no,
            party_name: value.party_name,
            total_amount: numberFormat(value.total_amount),
            profit: (
              <span style={{ color: value.net_profit < 0 ? 'red' : 'green' }}>
                {numberFormat(value.net_profit)}
              </span>
            ),
            actionExtra: _actionExtra,
          });

        });
      }
    }

    if (rows) {
      dataList = {
        columns: columns,
        rows: rows,
      };
    }
    return dataList;
  }

  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    });
    this.getSaleListData();
  };

  render() {
    if (this.state.isLoaded === true) {
      _loader = "glb-ldr-prt";
    }

    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># PROFIT ON SALE INVOICES</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-9">
                          <span>Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: { format: "YYYY-MM-DD" },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control col-7"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                        </div>
                        <div className="col-lg-3 text-right">
                          <div className="text-info">
                            <i className="fa fa-file-excel-o"></i> Excel Export
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row items-push mt-3">
                      <div className="col-lg-3">
                        <strong>Total Sale Amount:</strong> {this.state.totalSaleAmt}
                      </div>
                      <div className="col-lg-3" style={{ color: "green" }}>
                        <strong>Total Profit(+)/Loss(-):</strong> {this.state.totalProfitLoss}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-40px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block-content">
                  <h2 className="block-title ml-10">Transactions</h2>
                </div>
                <div className="block-content" id="tableData">
                  <MDBDataTableV5
                    hover
                    entriesOptions={[25, 50, 100, 500, 1000]}
                    entries={25}
                    pagesAmount={4}
                    span
                    pagingTop
                    searchTop
                    searchBottom={false}
                    barReverse
                    data={this.loadTranscListing()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Global Loader */}
        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>

        {/* Details Modal */}
        {this.state.showDetailsModal && (
          <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header bg-light">
                  <h5 className="modal-title">
                    Invoice #{this.state.detailsData?.invoice_no} - {this.state.detailsData?.party_name}
                  </h5>
                  <button type="button" className="close" onClick={this.closeDetailsModal}>
                    <span>&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  {!this.state.detailsData ? (
                    <p className="text-center m-0 py-3">Loading...</p>
                  ) : (
                    <div>
                      <h6 className="mb-3 mt-2 fw-bold text-secondary">Cost Calculation</h6>

                      <div className="table-responsive">
                        <table className="table table-sm table-bordered mb-3">
                          <thead className="thead-light">
                            <tr>
                              <th>Item Name</th>
                              <th className="text-end">Quantity</th>
                              <th className="text-end">Purchase Price</th>
                              <th className="text-end">Total Cost</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.detailsData.items.map((item, i) => (
                              <tr key={i}>
                                <td>{item.item_name}</td>
                                <td className="text-end">{item.quantity}</td>
                                <td className="text-end">{numberFormat(item.purchase_price)}</td>
                                <td className="text-end">{numberFormat(item.total_cost)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="mt-3">
                        <table className="table table-borderless">
                          <tbody>
                            <tr>
                              <td>Sale Amount</td>
                              <td className="text-end">{numberFormat(this.state.detailsData.sale_amount)}</td>
                            </tr>
                            <tr>
                              <td>Total Cost</td>
                              <td className="text-end">{numberFormat(this.state.detailsData.total_cost)}</td>
                            </tr>
                            <tr>
                              <td>Tax Payable</td>
                              <td className="text-end">{numberFormat(this.state.detailsData.tax_payable)}</td>
                            </tr>
                            <tr className="fw-bold border-top">
                              <td>Profit (Sale Amount - Total Cost - Tax Payable)</td>
                              <td className="text-end text-success">
                                {numberFormat(this.state.detailsData.profit)}
                              </td>
                            </tr>
                            <tr>
                              <td>Profit (Excluding Additional Charges)</td>
                              <td className="text-end text-success">
                                {numberFormat(this.state.detailsData.profit_excl_additional)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={this.closeDetailsModal}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      </React.Fragment>
    );
  }
}
